<template>
  <div class="est-room__details">
    <div class="est-room__with">
      <span class="est-room__avatar est-room__avatar--initials" aria-hidden="true">{{ initials(customerInfo.customerName) }}</span>
      <div class="est-room__with-body">
        <p class="est-room__with-label">{{ $t('Customer') }}</p>
        <p class="est-room__with-name">
          <a v-if="customerInfo.customerName" href="#" class="est-room__with-link" @click.prevent="createLink()">
            {{ customerInfo.customerName }} <font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" />
          </a>
        </p>
      </div>
    </div>

    <dl class="est-room__datalist">
      <template v-if="customerInfo.phone">
        <dt>{{ $t('Phone') }}</dt>
        <dd>{{ customerInfo.phone }}</dd>
      </template>
      <template v-if="customerInfo.dateOfBirth">
        <dt>{{ $t('DateOfBirth') }}</dt>
        <dd>{{ customerInfo.dateOfBirth | dateFormat }}</dd>
      </template>
      <template v-if="customerInfo.age && customerInfo.age > 0">
        <dt>{{ $t('Age') }}</dt>
        <dd>{{ customerInfo.age }}</dd>
      </template>
      <template v-if="customerInfo.lastVisitDate">
        <dt>{{ $t('LastAppointmentDate') }}</dt>
        <dd>{{ customerInfo.lastVisitDate }}</dd>
      </template>
    </dl>

    <template v-if="customerAppointments.length">
      <p class="est-room__subtitle">{{ $t('OnlineMeetingComponent.LastFiveAppointment') }}</p>
      <ul class="est-room__appts">
        <li v-for="(app, index) in customerAppointments" :key="index"
            class="est-room__appt" :class="{ 'is-now': app.id == meeting.appointmentID }">
          <span class="est-room__appt-date">{{ app.startDate }}</span>
          <span v-if="app.id == meeting.appointmentID" class="est-room__appt-now">{{ $t('Now') }}</span>
          <span v-else class="est-room__appt-time">{{ app.time }}</span>
          <span class="est-room__appt-services">{{ app.services }}</span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
  import MeetingService from '../../../services/meeting.js'
  import { nameInitials } from '../../../helpers/nameInitials'

  // Görüşme sırasında uzmanın gördüğü danışan özeti (yalnız host).
  export default {
    name: 'MeetingDetailsComponent',
    props: {
      meeting: {
        type: Object,
        default: null
      }
    },
    data: function () {
      return {
        customerInfo: {},
        customerAppointments: []
      }
    },
    methods: {
      initials: nameInitials,
      getCustomerDetails() {
        if (this.guestId) {
          MeetingService.getCustomerDetails(this.meeting.guestID)
            .then(response => {
              this.customerInfo = response || {};
            })
            .catch(error => console.error(error));
        }
      },
      createLink() {
        if (this.guestId) {
          let route = this.$router.resolve({ name: 'customerSummary', params: { customerId: this.meeting.guestID, elementId: 'aDetails' } })
          window.open(route.href, '_blank');
        }
      },
      getAppointments() {
        if (this.guestId) {
          MeetingService.getAppointments(this.meeting.guestID)
            .then(response => {
              this.customerAppointments = Array.isArray(response) ? response : [];
            })
            .catch(error => console.error(error));
        }
      }
    },
    computed: {
      guestId: function () {
        return this.meeting && this.meeting.guestID != null && this.meeting.guestID.length > 0;
      }
    },
    mounted: function () {
      this.getCustomerDetails();
      this.getAppointments();
    }
  }
</script>
